import script from "./MessageService.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageService.vue?vue&type=script&setup=true&lang=js"

import "./MessageService.vue?vue&type=style&index=0&id=09186402&lang=postcss&scoped=true"
script.__scopeId = "data-v-09186402"

export default script